module.exports = __webpack_public_path__ + "static/media/twitter-logo.e9b4741f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitter-logo.svg
// module id = 633
// module chunks = 8